<template>
    <BreadCrumb PageTitle="Modifier une zone tarifaire" />
    <EditTariffZone/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditTariffZone from "@/components/ZoneTarifaire/EditTariffZone.vue";
  
    export default defineComponent({
      name: "EditTariffZonePage",
      components: {
        BreadCrumb,
        EditTariffZone,
      },
    });
  </script>